import APIContext from 'contexts/base/APIContext'

export default class MpfOutstandingActionsContext extends APIContext{
  static contextName = 'mpfOutstandingActions'

  search = async(item, {...options}={}) => {
    const { data } = await this.performRequest('search')({...item, options})
    this.setState({list: data})
    return data
  }

  clear = async () => {
    this.setState({list: [], totalPages: 0, count: 0})
  }
}
